import { useState } from 'react';
import { Container, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import 'bootstrap/dist/css/bootstrap.min.css';

import voyceLogo from '../../Images/logo.png';
import './Header.css';
const Header = () => {
  const [language, setLanguage] = useState('English');
  const handleSelect = (eventKey) => {
    setLanguage(eventKey);
  };
  const navigate = useNavigate();

  return (
    <>
      <Navbar className= "Header-container" bg="white" expand="lg" >
        <Container fluid className="d-flex flex-lg-row align-items-center">
          <Navbar.Brand onClick={()=>{navigate("/Login")}}>
            <Image src={voyceLogo} alt="Logo" className="imge" />
          </Navbar.Brand>
          <Nav className="contact-language">
              <Nav.Link href="https://web.voyceglobal.com/contact" target="_blank">
                <div className="Hearder-contact-us underline">Contact Us</div>
              </Nav.Link>
            </Nav>
        </Container>
      </Navbar>
    </>
  );
};
export default Header;
